
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_swimc_6xhzf_9",
  "anchor-list": "awsui_anchor-list_swimc_6xhzf_41",
  "anchor-item": "awsui_anchor-item_swimc_6xhzf_65",
  "anchor-item--active": "awsui_anchor-item--active_swimc_6xhzf_85",
  "anchor-link": "awsui_anchor-link_swimc_6xhzf_103",
  "anchor-link--active": "awsui_anchor-link--active_swimc_6xhzf_145",
  "anchor-link-text": "awsui_anchor-link-text_swimc_6xhzf_152",
  "anchor-link-info": "awsui_anchor-link-info_swimc_6xhzf_156"
};
  